import filter from 'lodash/filter';
import _get from 'lodash/get';
import { SessionStorage } from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';

export const checkSizeWarning = (dimensionId, messages, enableErrorSizing) => {
    if (enableErrorSizing && messages[dimensionId] && messages[dimensionId].length > 0) {
        return messages[dimensionId][0]?.id === 'SIZEMessageId' || 'WIDTHMessageId';
    }
    return null;
};

export const getMaxSwatchLengthForMobile = (mobileWindowPadding) => {
    // default max swathces for mobile.
    let mobileMaxSwatches = 5;
    const swatchWidth = 40;
    const swatchMargin = 8;
    /* istanbul ignore else */
    if (typeof window !== 'undefined' && window.innerWidth) {
        mobileMaxSwatches = Math.floor(
            (window.innerWidth - mobileWindowPadding - swatchWidth) / (swatchWidth + swatchMargin)
        );
    }
    return mobileMaxSwatches;
};

export const getMaxSwatchLength = (
    deviceName,
    fromMiniPDP,
    enableColorCarousel,
    productDetails = {}
) => {
    const mobileWindowPadding = fromMiniPDP ? 40 : 32;

    let swatchCount = 0;
    const desktopSwatchCount = fromMiniPDP ? 17 : 9;
    let colorCarouselCount = 0;
    let colorCarouselCountTablet = 0;

    if (fromMiniPDP) {
        colorCarouselCount = productDetails.hybridIndicator ? 11 : 17;
    } else {
        colorCarouselCount = productDetails.hybridIndicator ? 13 : 19;
    }

    if (fromMiniPDP) {
        colorCarouselCountTablet = productDetails.hybridIndicator ? 13 : 20;
    } else {
        colorCarouselCountTablet = productDetails.hybridIndicator ? 11 : 17;
    }
    switch (deviceName) {
        case 'tablet':
            swatchCount = enableColorCarousel ? colorCarouselCountTablet : 20;
            break;
        case 'mobile':
            // number of swatches displayed per line (excluding the more/less btn)
            swatchCount = getMaxSwatchLengthForMobile(mobileWindowPadding);
            break;
        default:
            swatchCount = enableColorCarousel ? colorCarouselCount : desktopSwatchCount;
    }

    return swatchCount;
};

export const shouldDimensionPriceDisplay = (inventory) => {
    let displayOriginalPriceDimension = false;
    let displaySalePriceDimension = false;
    let displayClearancePriceDimension = false;
    inventory[0] &&
        inventory[0].lotPrice &&
        _get(inventory[0], 'lotPrice.data', []).forEach((item) => {
            if (item.manufacturerAdvertised) {
                item.amounts.forEach((details) => {
                    switch (details.type) {
                        case 'CLEARANCE':
                            /* istanbul ignore else */
                            if (!displayClearancePriceDimension) {
                                displayClearancePriceDimension = item.manufacturerAdvertised;
                            }
                            break;
                        case 'SALE':
                            /* istanbul ignore else */
                            if (!displaySalePriceDimension) {
                                displaySalePriceDimension = item.manufacturerAdvertised;
                            }
                            break;
                        case 'DEFAULT':
                            /* istanbul ignore else */
                            if (!displayOriginalPriceDimension) {
                                displayOriginalPriceDimension = item.manufacturerAdvertised;
                            }
                            break;
                        default:
                            break;
                    }
                });
            }
        });
    return {
        displayOriginalPriceDimension,
        displaySalePriceDimension,
        displayClearancePriceDimension,
    };
};

export const storeSkuInfo = (ppId = '', lotId, skuId, isSelectedItemAvailable) => {
    const RecentPDPSkuListStorage = SessionStorage.getData('RecentPDPSkuList', true);
    const skuSelected = {
        ppId,
        lotId,
        skuId: skuId || 'NA',
        status: (isSelectedItemAvailable && 'Available') || (skuId && 'NotAvailable') || 'NA',
    };
    if (RecentPDPSkuListStorage) {
        const RecentPDPSkuList = JSON.parse(RecentPDPSkuListStorage) || [];
        let filteredPpList = filter(RecentPDPSkuList, (item) => item.ppId !== ppId);
        filteredPpList.unshift(skuSelected);
        if (filteredPpList.length > 5) {
            filteredPpList = filteredPpList.slice(0, 5);
        }
        SessionStorage.setData('RecentPDPSkuList', filteredPpList, true);
    } else {
        SessionStorage.setData('RecentPDPSkuList', [skuSelected], true);
    }
};

export const renderPriceForDimensions = (dimension, dimensionPriceDisplay, saleAndClearence) => {
    /* istanbul ignore else */
    if (dimension.id === 'COLOR') {
        /* istanbul ignore else */
        if (
            dimension.priceType &&
            dimension.priceType.toLowerCase() === 'sale' &&
            !dimensionPriceDisplay.displaySalePriceDimension
        ) {
            return saleAndClearence.saleValue;
        }
        /* istanbul ignore else */
        if (
            dimension.priceType &&
            dimension.priceType.toLowerCase() === 'clearance' &&
            !dimensionPriceDisplay.displayClearancePriceDimension
        ) {
            return saleAndClearence.clearanceValue;
        }
        /* istanbul ignore else */
        if (
            dimension.priceType &&
            dimension.priceType.toLowerCase() === 'original' &&
            !dimensionPriceDisplay.displayOriginalPriceDimension
        ) {
            return saleAndClearence.originalValue;
        }
    }
    return null;
};

export const getImageObject = (productImage = {}, images = {}, altImages = []) => {
    if (productImage?.modelHeight && productImage?.modelWearingSize) {
        return productImage;
    }
    if (images?.modelHeight && images?.modelWearingSize) {
        return images;
    }
    if (altImages?.length) {
        let image = null;
        altImages.forEach((item) => {
            if (item?.modelHeight && item?.modelWearingSize && !image) {
                image = item;
            }
        });
        return image;
    }
    return {};
};

export default {
    checkSizeWarning,
    getMaxSwatchLength,
    getMaxSwatchLengthForMobile,
    shouldDimensionPriceDisplay,
    storeSkuInfo,
    renderPriceForDimensions,
    getImageObject,
};
